import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  avatar: {
    height: '40px',
    marginRight: theme.spacing(2),
    width: '40px',
  },
  lightPrimaryIcon: {
    color: theme.palette.primary.light,
  },
  title: {
    fontWeight: 600,
    lineHeight: '150%',
    marginBottom: theme.spacing(1)
  },
  visitTitle: {
    color: theme.palette.text.primary,
    fontSize: '.875rem',
    fontWeight: 600,
    lineHeight: '143%',
  },
}));
